import { memo, SVGProps } from 'react';

const Line12Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 1186 0' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0H1186' stroke='#6B6E8A' strokeWidth={0.5} strokeLinecap='round' />
  </svg>
);

const Memo = memo(Line12Icon);
export { Memo as Line12Icon };
